import * as style from './style.module.css';

const Divider = ({className = ''}) => (<hr className={`${style.divider} ${className}`}/>);

export default Divider;